import { LOGIN_USER, LOGOUT_USER, UPDATE_USER_INFO } from "./actionTypes";
import apiCall from "../../helpers/api";
import {
  CHANGE_PASSWORD_API_URL,
  LOGIN_API_URL,
  UPDATE_USER_INFO_API_URL,
} from "../../configs/url";
import axios from "axios";

export const loginUser = (email, pass, recaptcha) => (dispatch) => {
  return apiCall({
    method: "POST",
    url: LOGIN_API_URL,
    data: {
      email: email,
      password: pass,
      "g-recaptcha-response": recaptcha,
    },
  }).then((response) => {
    if (response.status === 200) {
      const user = response.data.data;
      return dispatch({
        type: LOGIN_USER,
        payload: user,
      });
    } else {
      throw new Error("Login failed");
    }
  });
};

export const updateUserInfo = () => (dispatch) => {
  return apiCall({
    method: "POST",
    url: UPDATE_USER_INFO_API_URL,
  }).then((response) => {
    if (response.status === 200) {
      const user = response.data.data;
      return dispatch({
        type: UPDATE_USER_INFO,
        payload: user,
      });
    } else {
      throw new Error("Update failed");
    }
  });
};

export const handleSocialLoginCallback = (token) => async (dispatch) => {
  try {
    const response = await axios.post(
      UPDATE_USER_INFO_API_URL,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      const user = response.data.data;
      dispatch({
        type: UPDATE_USER_INFO,
        payload: user,
      });
      return user; // Return actual user object
    } else {
      throw new Error("Social login callback failed");
    }
  } catch (error) {
    console.error("Error during social login callback:", error);
    throw error;
  }
};

export const logoutUser = () => (dispatch) => {
  return dispatch({
    type: LOGOUT_USER,
    payload: [],
  });
};
